import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mymodal',
    templateUrl: './mymodal.component.html',
    styleUrls: ['./mymodal.component.scss'],
    standalone: false
})
export class MymodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
